import lazy from '../utils/lazy';
import HomeRoutes from '../modules/home/routes';
import AboutUsDescriptionRoutes from '../modules/aboutUsDescription/routes';
import FuelPumpCatalogRoutes from '../modules/fuelPumpCatalog/routes';
import FuelPumpInfoRoutes from '../modules/fuelPumpInfo/routes';
import WhereBuyRoutes from '../modules/whereBuy/routes';
import ContactUsRoutes from '../modules/contactUs/routes';
import extendNotFound from './extendNotFound';

const childRoutes = extendNotFound([
  ...FuelPumpCatalogRoutes,
  ...HomeRoutes,
  ...AboutUsDescriptionRoutes,
  ...FuelPumpInfoRoutes,
  ...WhereBuyRoutes,
  ...ContactUsRoutes
]);

const routes: RouteInfo[] = [
  {
    path: '/',
    component: lazy(() => import('../App')),
    routes: childRoutes
  }
];

export default routes;
